import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroCarousel';
import VideoSection from '../components/VideoSection';
import VideoCarousel from '../components/VideoCarousel';
import AutoScrollCarousel from '../components/AutoScrollCarousel';

const Home = () => {
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchAllVideos = async () => {
      setLoading(true);
      try {
        console.log("Fetching new videos from API...");
        // Fetch new videos
        const newVideosResponse = await fetch('https://christian-videos-api.onrender.com/newvideos/500');
        if (!newVideosResponse.ok) {
            throw new Error('Network response was not ok for new videos');
        }
        const newVideosResult = await newVideosResponse.json();
        console.log("New videos API response:", newVideosResult);
        
        if (newVideosResult.error || !newVideosResult.data) {
            throw new Error('Invalid data structure from new videos API');
        }

        // Limit to 20-30 videos
        const newVideos = newVideosResult.data.slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        console.log("Processed new videos count:", newVideos.length);

        // Fetch M A Varughese videos
        console.log("Fetching M A Varughese videos...");
        const maVarugheseResponse = await fetch('https://christian-videos-api.onrender.com/category/506/500');
        if (!maVarugheseResponse.ok) {
            throw new Error('Network response was not ok for M A Varughese');
        }
        const maVarugheseResult = await maVarugheseResponse.json();
        console.log("M A Varughese API response:", maVarugheseResult);

        const maVarugheseVideos = (maVarugheseResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Rev. Johnson V videos
        console.log("Fetching Rev. Johnson V videos...");
        const revJohnsonResponse = await fetch('https://christian-videos-api.onrender.com/category/551/500');
        if (!revJohnsonResponse.ok) {
            throw new Error('Network response was not ok for Rev. Johnson V');
        }
        const revJohnsonResult = await revJohnsonResponse.json();
        console.log("Rev. Johnson V API response:", revJohnsonResult);

        const revJohnsonVideos = (revJohnsonResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch TD Jakes videos
        console.log("Fetching TD Jakes videos...");
        const tdJakesResponse = await fetch('https://christian-videos-api.onrender.com/category/556/500');
        if (!tdJakesResponse.ok) {
            throw new Error('Network response was not ok for TD Jakes');
        }
        const tdJakesResult = await tdJakesResponse.json();
        console.log("TD Jakes API response:", tdJakesResult);

        const tdJakesVideos = (tdJakesResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Bro Suresh Babu videos
        console.log("Fetching Bro Suresh Babu videos...");
        const sureshBabuResponse = await fetch('https://christian-videos-api.onrender.com/category/508/500');
        if (!sureshBabuResponse.ok) {
            throw new Error('Network response was not ok for Bro Suresh Babu');
        }
        const sureshBabuResult = await sureshBabuResponse.json();
        console.log("Bro Suresh Babu API response:", sureshBabuResult);

        const sureshBabuVideos = (sureshBabuResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Tamil Songs videos
        console.log("Fetching Tamil Songs...");
        const tamilSongsResponse = await fetch('https://christian-videos-api.onrender.com/category/516/500');
        if (!tamilSongsResponse.ok) {
            throw new Error('Network response was not ok for Tamil Songs');
        }
        const tamilSongsResult = await tamilSongsResponse.json();
        console.log("Tamil Songs API response:", tamilSongsResult);

        const tamilSongsVideos = (tamilSongsResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Steven Furtick videos
        console.log("Fetching Steven Furtick videos...");
        const stevenFurtickResponse = await fetch('https://christian-videos-api.onrender.com/category/562/20');
        if (!stevenFurtickResponse.ok) {
            throw new Error('Network response was not ok for Steven Furtick');
        }
        const stevenFurtickResult = await stevenFurtickResponse.json();
        console.log("Steven Furtick API response:", stevenFurtickResult);

        const stevenFurtickVideos = (stevenFurtickResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Malayalam Songs videos
        console.log("Fetching Malayalam Songs...");
        const malayalamSongsResponse = await fetch('https://christian-videos-api.onrender.com/category/515/20');
        if (!malayalamSongsResponse.ok) {
            throw new Error('Network response was not ok for Malayalam Songs');
        }
        const malayalamSongsResult = await malayalamSongsResponse.json();
        console.log("Malayalam Songs API response:", malayalamSongsResult);

        const malayalamSongsVideos = (malayalamSongsResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch English Songs videos
        console.log("Fetching English Songs...");
        const englishSongsResponse = await fetch('https://christian-videos-api.onrender.com/category/514/20');
        if (!englishSongsResponse.ok) {
            throw new Error('Network response was not ok for English Songs');
        }
        const englishSongsResult = await englishSongsResponse.json();
        console.log("English Songs API response:", englishSongsResult);

        const englishSongsVideos = (englishSongsResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Fetch Anish Mano Stephen videos
        console.log("Fetching Anish Mano Stephen videos...");
        const anishManoResponse = await fetch('https://christian-videos-api.onrender.com/category/571/20');
        if (!anishManoResponse.ok) {
            throw new Error('Network response was not ok for Anish Mano Stephen');
        }
        const anishManoResult = await anishManoResponse.json();
        console.log("Anish Mano Stephen API response:", anishManoResult);

        const anishManoVideos = (anishManoResult.data || []).slice(0, 25).map(video => ({
            id: video.id,
            title: video.video_title,
            poster: `https:${video.yt_thumb}`
        }));

        // Create sections
        const allSections = [
          {
            title: 'New Videos',
            videos: newVideos
          },
          {
            title: 'Rev. Johnson V',
            videos: revJohnsonVideos
          },
          {
            title: 'M A Varughese',
            videos: maVarugheseVideos
          },
          {
            title: 'Bro Suresh Babu',
            videos: sureshBabuVideos
          },
          {
            title: 'Tamil Songs',
            videos: tamilSongsVideos
          },
          {
            title: 'Malayalam Songs',
            videos: malayalamSongsVideos
          },
          {
            title: 'English Songs',
            videos: englishSongsVideos
          },
          {
            title: 'Steven Furtick',
            videos: stevenFurtickVideos
          },
          {
            title: 'Anish Mano Stephen',
            videos: anishManoVideos
          },
          {
            title: 'TD Jakes',
            videos: tdJakesVideos
          }
        ];

        console.log("Sections to display:", allSections);
        setSections(allSections);

      } catch (error) {
        console.error("Failed to fetch videos:", error);
        // Fallback to mock data
        const mockData = [
          {
            title: 'New Videos',
            videos: [
              { id: '100', title: 'Sample New Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '101', title: 'Sample New Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
              { id: '102', title: 'Sample New Video 3', poster: 'https://image.tmdb.org/t/p/w500/sKk0p3aI432aI1s3i0eZlK1mYv.jpg' },
              { id: '103', title: 'Sample New Video 4', poster: 'https://image.tmdb.org/t/p/w500/k3Iu2Heag2dJ18Iey73c2kPUn0.jpg' },
              { id: '104', title: 'Sample New Video 5', poster: 'https://image.tmdb.org/t/p/w500/xUfRZu2mi8jH6SzQEJ9paVwcfSc.jpg' },
            ]
          },
          {
            title: 'M A Varughese',
            videos: [
              { id: '200', title: 'M A Varughese Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '201', title: 'M A Varughese Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Bro Suresh Babu',
            videos: [
              { id: '250', title: 'Bro Suresh Babu Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '251', title: 'Bro Suresh Babu Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Tamil Songs',
            videos: [
              { id: '260', title: 'Tamil Song 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '261', title: 'Tamil Song 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Malayalam Songs',
            videos: [
              { id: '270', title: 'Malayalam Song 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '271', title: 'Malayalam Song 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'English Songs',
            videos: [
              { id: '280', title: 'English Song 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '281', title: 'English Song 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Steven Furtick',
            videos: [
              { id: '350', title: 'Steven Furtick Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '351', title: 'Steven Furtick Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Anish Mano Stephen',
            videos: [
              { id: '360', title: 'Anish Mano Stephen Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '361', title: 'Anish Mano Stephen Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'Rev. Johnson V',
            videos: [
              { id: '300', title: 'Rev. Johnson V Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '301', title: 'Rev. Johnson V Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          },
          {
            title: 'TD Jakes',
            videos: [
              { id: '400', title: 'TD Jakes Video 1', poster: 'https://image.tmdb.org/t/p/w500/sA217gwpbA4n3o02s2E1iWbNl3d.jpg' },
              { id: '401', title: 'TD Jakes Video 2', poster: 'https://image.tmdb.org/t/p/w500/u5zltgDEDCBV4aG2gLp1a4S2S3c.jpg' },
            ]
          }
        ];
        setSections(mockData);
      } finally {
        setLoading(false);
      }
    };

    fetchAllVideos();
  }, []);

  const handleVideoClick = (videoId) => {
    navigate(`/watch/${videoId}`);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-brand-dark text-white">Loading...</div>;
  }

  return (
    <div className="bg-brand-dark min-h-screen">
      <SEO 
        title="Christian Videos - Today's Popular Messages"
        description="At ChristianVideos, enjoy Christian Messages, Worship songs and Bible Study Videos to build spiritual and brighten your day. - Today's Popular Messages."
        url="https://christianvideos.in/"
      />
      <HeroSection />
      <div className="px-4 sm:px-6 md:px-8 lg:pl-20 lg:pr-8">
        <div className="py-8 space-y-6">
          {sections.map((section, index) => (
            index === 0 ? (
              <AutoScrollCarousel
                key={section.title}
                title={section.title}
                videos={section.videos}
                onVideoClick={handleVideoClick}
              />
            ) : (
              <VideoCarousel
                key={section.title}
                title={section.title}
                videos={section.videos}
                onVideoClick={handleVideoClick}
              />
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
